export default __webpack_public_path__ + "static/media/CV-IMG.ce015990.png";